export const AC_SERVER_ADDRESS = "https://api.ccdtn.com";
// export const AC_SERVER_ADDRESS = "http://localhost";
export const AC_SERVER_PORT = 8765;
export const acServerAddress = `${AC_SERVER_ADDRESS}:${AC_SERVER_PORT}`;

// BFF服务器地址配置
export const BFF_SERVER_ADDRESS = "https://api.ccdtn.com";
// export const BFF_SERVER_ADDRESS = "http://localhost";
export const BFF_SERVER_PORT = 8654;
export const bffServerAddress = `${BFF_SERVER_ADDRESS}:${BFF_SERVER_PORT}`;

// BFF代理路径配置（通过BFF访问后端服务，自动携带认证信息）
const CLIENT_ID = 'file-client';
const BFF_PROXY_BASE = `${bffServerAddress}/api/bff/${CLIENT_ID}`;

export const userServerAddress = `${BFF_PROXY_BASE}/user`;

// 直接访问后端服务（用于不需要认证的接口，如注册）
export const DIRECT_USER_SERVER_ADDRESS = "https://api.ccdtn.com";
// export const DIRECT_USER_SERVER_ADDRESS = "http://localhost";
export const DIRECT_USER_SERVER_PORT = 8543;
export const directUserServerAddress = `${DIRECT_USER_SERVER_ADDRESS}:${DIRECT_USER_SERVER_PORT}`;

// export const hostServerAddress = "https://uc.ccdtn.com";
export const hostServerAddress = "https://user.wisememo.com";
// export const hostServerAddress = "http://localhost:5234";

export const DEFAULT_SECTION_GUID = "_";
export const DEFAULT_GROUP_GUID = "_";

export const SOURCE_ID = "CCDTN";

export const DEFAULT_LANGUAGE = "zhCN";

import { createTheme } from "@mui/material/styles";
export let defaultTheme = createTheme({
  palette: {
    primary: {
      light: "#26d0ce",
      main: "#1a2980",
      dark: "#0f1a5c",
      contrastText: "#FFFFFF",
    },
    secondary: {
      light: "#FFD54F",
      main: "#FFC107",
      dark: "#FFA000",
      contrastText: "#212121",
    },
    success: {
      light: "#81C784",
      main: "#4CAF50",
      dark: "#388E3C",
      contrastText: "#FFFFFF",
    },
    warning: {
      light: "#FFB74D",
      main: "#FF9800",
      dark: "#F57C00",
      contrastText: "#212121",
    },
    error: {
      light: "#E57373",
      main: "#F44336",
      dark: "#D32F2F",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#f8fafc",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#1e293b",
      secondary: "#64748b",
      disabled: "#94a3b8",
    },
    divider: "#e2e8f0",
  },
  typography: {
    fontFamily:
      '"Poppins", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: "2.5rem",
      lineHeight: 1.2,
    },
    h2: {
      fontWeight: 600,
      fontSize: "2rem",
      lineHeight: 1.3,
    },
    h3: {
      fontWeight: 600,
      fontSize: "1.75rem",
      lineHeight: 1.3,
    },
    h4: {
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: 1.4,
    },
    h5: {
      fontWeight: 600,
      fontSize: "1.25rem",
      lineHeight: 1.4,
    },
    h6: {
      fontWeight: 600,
      fontSize: "1.125rem",
      lineHeight: 1.4,
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: "1rem",
      lineHeight: 1.5,
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: "0.875rem",
      lineHeight: 1.5,
    },
    body1: {
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.6,
    },
    body2: {
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: 1.5,
    },
    button: {
      fontWeight: 600,
      fontSize: "0.875rem",
      textTransform: "none",
    },
    caption: {
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: 1.4,
    },
  },
  shape: {
    borderRadius: 12,
  },
  shadows: [
    "none",
    "0px 1px 2px rgba(0, 0, 0, 0.05)",
    "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
    "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
    "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)",
    "0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "0px 25px 50px -12px rgba(0, 0, 0, 0.25)",
    ...Array(19).fill("none"),
  ] as any,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "10px 20px",
          fontWeight: 600,
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            boxShadow: "0px 6px 12px rgba(26, 41, 128, 0.25)",
            transform: "translateY(-2px)",
          },
        },
        containedPrimary: {
          background: "linear-gradient(135deg, #1a2980 0%, #26d0ce 100%)",
          "&:hover": {
            background: "linear-gradient(135deg, #0f1a5c 0%, #1fb8b6 100%)",
            boxShadow: "0px 8px 16px rgba(26, 41, 128, 0.3)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
          border: "1px solid rgba(226, 232, 240, 0.8)",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            boxShadow: "0px 12px 32px rgba(0, 0, 0, 0.12)",
            transform: "translateY(-4px)",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: "linear-gradient(135deg, #1a2980 0%, #26d0ce 100%)",
          boxShadow: "0px 4px 12px rgba(26, 41, 128, 0.2)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          borderRadius: "0px",
        },
      },
    },
  },
});
